import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { Icon, IconName, ListItem } from '@optimus-web/core';

interface Props {
    onClick: $TSFixMeFunction;
}

const PdfLink = ({ onClick }: Props) => (
    <ListItem
        primaryText={<LocalizedText textKey={TextKey.PrintCustom} />}
        onClick={onClick}
        leftIcon={<Icon value={IconName.PrintPdf} />}
    />
);

export default PdfLink;
